import React, {Dispatch, SetStateAction} from 'react';
import {Box, Card, CardContent, Chip, Typography, IconButton} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

import {IQuestion} from '../../../classes/Question';
import {ISurvey} from '../../../classes/Survey';

interface IProps {
    survey: ISurvey,
    questions: IQuestion[], // Unused in this dummy component
    setViewQuestionsData: Dispatch<SetStateAction<boolean>>, // Unused in this dummy component
    setViewComparative: Dispatch<SetStateAction<boolean>>, // Unused in this dummy component
}

const rowsData = [
    {
        score: 3.80,
        level: 'Alto',
        levelColor: 'success' as const,
        interpretation: 'El evaluado evidencia autocontrol con regularidad. Habitualmente se comporta de manera sopesada, paciente y analítica, incluso ante desafíos, demostrando la presencia del rasgo por encima del promedio.',
        recommendations: 'Foco en Modelado: Alentarlo a que se convierta en un recurso de apoyo o mentor para colegas que necesitan desarrollar esta competencia. Asignarle responsabilidades de alto nivel que requieran una gestión constante de conflictos o situaciones de presión alta.'
    },
    {
        score: 3.79,
        level: 'Medio',
        levelColor: 'warning' as const,
        interpretation: 'El evaluado muestra una expresión moderada del rasgo. Puede manejar la presión en ciertos contextos, pero su desempeño no es dominante o consistente. En situaciones de presión sostenida o múltiple, muestra dificultad para mantener la calidad.',
        recommendations: 'Foco en la Resistencia: Identificar los tipos de presión (plazo, complejidad, impacto) que más le afectan. Entrenarlo en técnicas de relajación rápida y reestructuración cognitiva para mantener la claridad mental. Proporcionar feedback inmediato sobre cómo gestiona la presión en proyectos clave.'
    }
];


const SurveyDashboardOverviewDummyData = (props: IProps) => {

    const navigate = useNavigate();

    return (
        <>
            {/* Improved Title Bar with Back Button */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    p: 2,
                    mx: 3,
                    mt: 2,
                }}
            >
                <IconButton
                    onClick={() => navigate('/surveys')}
                    sx={{ mr: 1 }}
                    aria-label="go back"
                >
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h5" component="h1" fontWeight="600" sx={{flexGrow: 1}}>
                    {props.survey.title}
                </Typography>
            </Box>

            <Box sx={{flexGrow: 1, px: 3, mt: 1}}>
                {rowsData.map((row, index) => (
                    <Grid container spacing={3} key={index} sx={{mb: index < rowsData.length - 1 ? 4 : 0}}>
                        {/* Score Card */}
                        <Grid xs={12} md={4}>
                            <Card variant="outlined" sx={{height: '100%', display: 'flex', flexDirection: 'column', borderRadius: 4}}>
                                <CardContent sx={{flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', p: 3}}>
                                    <Typography variant="h2" component="div" fontWeight="bold" color="text.primary">
                                        {row.score.toFixed(2)}
                                    </Typography>
                                    <Chip label={row.level} color={row.levelColor} sx={{mt: 1.5}}/>
                                </CardContent>
                            </Card>
                        </Grid>
                        {/* Interpretation Card */}
                        <Grid xs={12} md={4}>
                            <Card variant="outlined" sx={{height: '100%', borderRadius: 4}}>
                                <CardContent sx={{p: 3}}>
                                    <Typography gutterBottom variant="h6" component="div" fontWeight="medium">
                                        INTERPRETACIÓN
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {row.interpretation}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        {/* Recommendations Card */}
                        <Grid xs={12} md={4}>
                            <Card variant="outlined" sx={{height: '100%', borderRadius: 4}}>
                                <CardContent sx={{p: 3}}>
                                    <Typography gutterBottom variant="h6" component="div" fontWeight="medium">
                                        RECOMENDACIONES
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {row.recommendations}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                ))}
            </Box>
        </>
    )
}

export default SurveyDashboardOverviewDummyData;